import React from 'react';
import { FormattedMessage } from 'react-intl';
import Dotdotdot from 'react-dotdotdot';

import { ProfileImage } from '@xingternal/profile-image';
import { Meta, Headline } from '@xingternal/typography';
import { Card } from '@xingternal/card';

import { FormattedTimestamp } from '@xingternal/pages-common';
import { getTrackingUrl } from '@xingternal/pages-tracking';

import JobsBookmark from '../JobsBookmark';

import match from './assets/match.svg'; // eslint-disable-line

import styles from './Jobs.css';
import { JobCard } from '../types';

type JobsCardProps = {
  job: JobCard;
};

const JobsCard: React.FC<JobsCardProps> = ({ job }) => (
  <Card
    target="_blank"
    key={job.id}
    href={job?.link}
    onClick={(ev: MouseEvent) => {
      ev.preventDefault();
      window.open(
        getTrackingUrl({
          to: job.link,
          trackingKey: 'viewJobProfile',
        }),
        '_blank'
      );
    }}
    linkProps={{
      // @ts-ignore
      'aria-label': 'job details link',
    }}
    className={styles.card}
  >
    <div className={styles.cardHeader}>
      {job.companyLogo && (
        <ProfileImage
          size="xxsmall"
          profileName={job.companyName}
          src={job.companyLogo}
          type="company"
        />
      )}
      <Meta size={'xsmall'} className={styles.companyName}>
        {job.companyName}
      </Meta>
      <JobsBookmark jobId={job.id} bookmarked={job.bookmarked} />
    </div>
    <div className={styles.body}>
      <Headline size={'medium'} className={styles.cardTitle} as="strong">
        <Dotdotdot clamp={2}>{job.title}</Dotdotdot>
      </Headline>
      <Meta size={'xsmall'} className={styles.location}>
        {job.location}
      </Meta>
    </div>
    <div className={styles.footer}>
      <div className={styles.matchContainer}>
        {typeof job.match === 'number' && (
          <>
            <img
              src={match}
              alt="Match"
              className={styles.matchIcon}
              loading="lazy"
            />
            <Meta noMargin className={styles.footerText}>
              <FormattedMessage
                id="EP_JOBS_MATCH"
                defaultMessage="EP_JOBS_MATCH"
                values={{ number: job.match }}
              />
            </Meta>
          </>
        )}
      </div>
      {job.activatedAt && (
        <Meta noMargin className={styles.footerText}>
          <FormattedTimestamp date={job.activatedAt} />
        </Meta>
      )}
    </div>
  </Card>
);

export default JobsCard;
